import { useQuery } from '@tanstack/react-query';

import { fetchCompanyList } from '../data-provider/company-list';

export const useGetCompanyList = () => {
  return useQuery({
    queryFn: () => fetchCompanyList(),
    queryKey: ['company-list'],
    // biome-ignore lint/style/noMagicNumbers: 1 min
    staleTime: 1000 * 60 * 1,
  });
};
